import { ApiService } from "../..";

export const updateSampleGroupSamples = (
  groupId: string,
  data: {
    append?: string[];
    remove?: string[];
  }
) => {
  return ApiService.baseAction(
    `sample-group/${groupId}/update_sample`,
    { data },
    "post"
  );
};
